import * as React from 'react';

import { LoyaltyEducationPerks } from 'models/common/loyalty-education';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

interface LoyaltyEducationContentProps {
  perks: LoyaltyEducationPerks;
}

export const LoyaltyEducationPerksContent: React.FunctionComponent<LoyaltyEducationContentProps> = ({ perks }) => {
  if (!perks) {
    return null;
  }

  return (
    <div className="all-b-margin-three">
      {perks.icon ? (
        perks.descriptions.map((listItem, index) => (
          <li className="uitk-grid all-t-margin-two" key={index}>
            <UitkIcon name={perks.icon} className="uitk-cell all-cell-shrink all-r-margin-two" size={UitkIconSize.SMALL} />
            <span className="uitk-cell all-cell-3-4 uitk-type-paragraph-300">{listItem}</span>
          </li>
        ))
      ) : (
        <ul className="uitk-type-list-300">
          {perks.descriptions.map((listItem, index) => (
            <li key={index}>{listItem}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
LoyaltyEducationPerksContent.displayName = 'LoyaltyEducationPerksContent';
